import { Deserializable } from "../deserializable";


export class SignIn implements Deserializable{
    email: string;
    password: string;

    deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }
}